import styled from "styled-components";

export const LabelHeading = styled.div`
// font-family: Mars Centra;
font-size: 16px;
font-weight: 700;
line-height: 26px;
text-align: left;
text-underline-position: from-font;
text-decoration-skip-ink: none;
`